const KEY = 'cmp.consent.v1';
export class LocalStorageConsentStore {
    read() {
        try {
            const raw = globalThis.localStorage?.getItem(KEY);
            return raw ? JSON.parse(raw) : null;
        }
        catch {
            return null;
        }
    }
    write(state) {
        try {
            globalThis.localStorage?.setItem(KEY, JSON.stringify(state));
        }
        catch {
            // ignore quota/availability errors
        }
    }
    clear() {
        try {
            globalThis.localStorage?.removeItem(KEY);
        }
        catch {
            // ignore
        }
    }
}
//# sourceMappingURL=store.local.js.map